<template>
	<div
		class="tutorial-arrows"
		:class="{
			'tutorial-arrows--top': top,
			'tutorial-arrows--right': right,
			'tutorial-arrows--bottom': bottom,
			'tutorial-arrows--left': left,
		}"
		:style="{
			/* NOTE: Only left for horizontal correction, because origin is top left */
			/* NOTE: Default is vertically centered */
			'--arrows-width': `${arrowsWidth}rem`,
			top: top ? `${topOffset - verticalCorrection}px` : undefined,
			left: left
				? `${leftOffset - arrowsWidth * 16 - horizontalCorrection}px`
				: right
					? `${rightOffset + horizontalCorrection}px`
					: undefined,
			bottom: bottom
				? `${bottomOffset + verticalCorrection}px`
				: undefined,
		}"
	/>
</template>

<script lang="ts" setup>
interface Props {
	top?: boolean;
	topOffset?: number;
	left?: boolean;
	leftOffset?: number;
	bottom?: boolean;
	bottomOffset?: number;
	right?: boolean;
	rightOffset?: number;
}

const {
	top = false,
	topOffset = 0,
	left = false,
	leftOffset = 0,
	bottom = false,
	bottomOffset = 0,
	right = false,
	rightOffset = 0,
} = defineProps<Props>();

const verticalCorrection = 10;
const horizontalCorrection = 10;
const arrowsWidth = 5.625; // in rem
</script>

<style lang="scss" scoped>
.tutorial-arrows {
	// TODO GRAPHIC: resize asset + add glow effect
	$width: var(--arrows-width); // load width dynamically
	$verticalCenter: translateY(-50%);
	$horizontalCenter: translateX(-50%);

	position: absolute;
	@include background(
		url($path-images + "tutorial/tutorial-arrows.webp"),
		contain,
		center,
		no-repeat
	);
	width: $width;
	height: 4.125rem;

	// TODO top
	// &--top {
	// }

	// TODO bottom
	// &--bottom {
	// }

	&--left {
		top: 50%;
		transform: scaleX(1) $verticalCenter; // left direction
	}

	&--right {
		top: 50%;
		transform: scaleX(-1) $verticalCenter; // flip horizontally for right direction
	}
}
</style>
